import PropTypes from "prop-types"
import React, { useState } from "react"

import Button from "src/components/Button"

import { useTracker } from "src/hooks/use_tracker"

import CloseWorkOrderModal from "./CloseWorkOrderModal"
import ReopenWorkOrderModal from "./ReopenWorkOrderModal"

const WorkOrderActions = ({ workOrder, workOrderSequentialId }) => {
  const [isCloseOpen, setIsCloseOpen] = useState(false)
  const [isReopenOpen, setIsReopenOpen] = useState(false)
  const isClosed = workOrder.status === "closed"
  const tracker = useTracker()

  const openCloseModal = () => {
    tracker.trackEvent("work_orders:close_work_order:clicked", {
      workOrderSequentialId,
    })
    setIsCloseOpen(true)
  }

  const openReopenModal = () => {
    tracker.trackEvent("work_orders:reopen_work_order:clicked", {
      workOrderSequentialId,
    })
    setIsReopenOpen(true)
  }

  return (
    <>
      {isClosed ? (
        <Button variant="secondary" onClick={openReopenModal}>
          Reopen Work Order
        </Button>
      ) : (
        <Button variant="secondary" onClick={openCloseModal}>
          Close Work Order
        </Button>
      )}

      <CloseWorkOrderModal
        isOpen={isCloseOpen}
        onClose={() => setIsCloseOpen(false)}
        workOrder={workOrder}
        workOrderSequentialId={workOrderSequentialId}
      />
      <ReopenWorkOrderModal
        isOpen={isReopenOpen}
        onClose={() => setIsReopenOpen(false)}
        workOrder={workOrder}
        workOrderSequentialId={workOrderSequentialId}
      />
    </>
  )
}

WorkOrderActions.propTypes = {
  workOrder: PropTypes.shape({
    status: PropTypes.string,
    displaySequentialId: PropTypes.string,
    contact: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
    }),
    contactBoat: PropTypes.shape({ name: PropTypes.string }),
  }).isRequired,
  workOrderSequentialId: PropTypes.string.isRequired,
}

export default WorkOrderActions
